// auth action types
export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";

// newReleases action types
export const SET_NEW_RELEASES = "SET_NEW_RELEASES";

// artists action types
export const SET_ARTISTS = "SET_ARTIST";

// current session action types
export const SET_PLAYING_SONG = "SET_PLAYING_SONG";
export const SET_NEW_SONG = "SET_NEW_SONG";
export const SET_SONG_INDEX = "SET_SONG_INDEX";
export const INC_SONG_INDEX = "INC_SONG_INDEX";
export const DEC_SONG_INDEX = "DEC_SONG_INDEX";
export const SET_ARTIST = "SET_ARTIST";
export const TOGGLE_IS_SONGLIST_OPEN = "TOGGLE_IS_SONGLIST_OPEN";

export const SET_PLAYLISTS = "SET_PLAYLISTS";
